module.exports = __webpack_public_path__ + "static/media/bulk_user_upload_example.9bbde618.csv";